import axios from "axios";

const Api = axios.create({
    //baseURL : `${global.config.live_url}/api`,
    baseURL : `https://menastockinstore.com/api`,
});

// Add an interceptor for all requests

Api.interceptors.request.use( config => {
    const accessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzkxOTU2OTExLCJpYXQiOjE3ODkzNjQ5MTEsImp0aSI6IjViMDUxN2ZlYTRmZDRmMThhMmJhNWJiODdiZmQyNmU2IiwidXNlcl9pZCI6MX0.NjRhho7pjxRsTxT4tZQr33YLz1S7FiFu88DwGH1HjX4";
    config.headers.Authorization = `Bearer ${accessToken}`;
    return config;

});
export default Api;